import React from 'react';
import SalesActionGridView from './SalesActionGrideView';

const SalesActionGrid = ({ timeSlots = [], actions = [], selectedDate, onSelectSchedule }) => {
    const SLOT_HEIGHT = 40;

    const formatDateToYMD = (dateObj) => {
        if (!dateObj || !(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const parseDatetime = (datetimeStr) => {
        if (!datetimeStr) return { date: '', time: '00:00' };
        const parts = datetimeStr.includes(' ') ? datetimeStr.split(' ') : datetimeStr.split('T');
        return { date: parts[0] || '', time: (parts[1] || '00:00').substring(0, 5) };
    };

    const timeToMinutes = (timeStr) => {
        if (!timeStr) return 0;
        const [hours, minutes] = timeStr.split(':').map(Number);
        return hours * 60 + minutes;
    };

    const targetDateStr = formatDateToYMD(selectedDate);

    const todayActions = actions.filter(action => {
        const { date: startDate } = parseDatetime(action.start);
        const { date: endDate } = parseDatetime(action.end);
        return startDate <= targetDateStr && endDate >= targetDateStr;
    });

    const gridStartMinutes = timeSlots.length > 0 ? timeToMinutes(timeSlots[0]) : 360;
    const gridEndMinutes = timeSlots.length > 0 ? timeToMinutes(timeSlots[timeSlots.length - 1]) + 30 : 1470;

    const calculatedActions = todayActions.map(action => {
        const { date: startDate, time: startTime } = parseDatetime(action.start);
        const { date: endDate, time: endTime } = parseDatetime(action.end);

        const finalStartTime = startDate === targetDateStr ? startTime : "06:00";
        const finalEndTime = endDate === targetDateStr ? endTime : "24:00";

        const startMin = timeToMinutes(finalStartTime);
        const endMin = timeToMinutes(finalEndTime);

        const clampedStartMin = Math.max(gridStartMinutes, startMin);
        const clampedEndMin = Math.min(gridEndMinutes, endMin);

        const pixelPerMinute = SLOT_HEIGHT / 30;
        const top = (clampedStartMin - gridStartMinutes) * pixelPerMinute;
        const height = (clampedEndMin - clampedStartMin) * pixelPerMinute;

        return {
            ...action,
            startMin: clampedStartMin,
            endMin: clampedEndMin,
            top,
            height
        };
    }).filter(a => a.height > 0);

    calculatedActions.sort((a, b) => a.startMin - b.startMin);

    const columns = [];
    calculatedActions.forEach(action => {
        let placed = false;
        for (let i = 0; i < columns.length; i++) {
            const lastActionInCol = columns[i][columns[i].length - 1];
            if (action.startMin >= lastActionInCol.endMin) {
                columns[i].push(action);
                action.colIdx = i;
                placed = true;
                break;
            }
        }
        if (!placed) {
            columns.push([action]);
            action.colIdx = columns.length - 1;
        }
    });

    calculatedActions.forEach(action => {
        const overlappingActions = calculatedActions.filter(other => {
            return (action.startMin < other.endMin && action.endMin > other.startMin);
        });
        const activeCols = new Set(overlappingActions.map(a => a.colIdx)).size;
        action.totalCols = Math.max(activeCols, 1);
    });

    return (
        <SalesActionGridView 
            timeSlots={timeSlots}
            calculatedActions={calculatedActions}
            slotHeight={SLOT_HEIGHT}
            onSelectSchedule={onSelectSchedule}
        />
    );
};

export default SalesActionGrid;
